import React, { Component } from 'react'
import Carousel from 'nuka-carousel'
import cn from 'classnames'

import styles from './Showcase.module.css'

const slides = [
  {
    name: 'Travis',
    className: 'travis',
  },
  {
    name: 'Supercoach',
    className: 'supercoach',
  },
  {
    name: 'Fundler',
    className: 'primepilot',
  },
]

const decorators = [
  {
    component: ({ currentSlide, slideCount, previousSlide, nextSlide }) => {
      return (
        <div className={styles.decorator}>
          <div className={styles.information}>
            <p className={styles.count}>0{currentSlide + 1} / 0{slideCount}</p>
            <p className={styles.name}>{slides[currentSlide].name}</p>
          </div>
          <div className={styles.navigation}>
            <div
              className={styles.chevronLeft}
              onClick={previousSlide}
            />
            <div
              className={styles.chevronRight}
              onClick={nextSlide}
            />
          </div>
        </div>
      )
    },
    position: 'TopCenter',
    style: {
      width: '100%',
    },
  },
]

class Slide extends Component {
  componentDidMount() {
    this.setupParallax()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }

  setupParallax() {
    this.requested = false
    window.addEventListener('scroll', this.onScroll)
  }

  onScroll = () => {
    if (!this.requested) {
      this.requested = true
      window.requestAnimationFrame(() => {
        this.ref.style.transform = `translate3d(0, ${Math.round(window.pageYOffset / 6)}px, 0)`
        this.requested = false
      })
    }
  }

  showClients() {
    window.scroll({ top: document.getElementById('clientsContainer').offsetTop - 50, left: 0, behavior: 'smooth' });
  }

  render() {
    const { slide } = this.props
    return (
      <div className={styles.slideContainer} ref={ref => this.ref = ref} onClick={this.showClients}>
        <div className={cn(styles.slide, styles[slide.className])} />
      </div>
    )
  }
}

export default React.createClass({
  mixins: [Carousel.ControllerMixin],

  render() {
    return (
      <div className={styles.container}>
        <Carousel
          decorators={decorators}
          autoplayInterval={2500}
          wrapAround
          easing="easeInOutCubic"
        >
          {slides.map((slide, i) => <Slide slide={slide} key={i} />)}
        </Carousel>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/Showcase.js